(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-raies-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.al-raies-hero').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-dot]'));
    if (slides.length < 2) return;
    let active = 0;
    const selectSlide = (index) => {
      active = index;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === active); dot.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
    };
     dots.forEach((dot, index) => dot.addEventListener('click', () => selectSlide(index)));
    if (hero.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(() => selectSlide((active + 1) % slides.length), Number(hero.dataset.interval) || 6000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
